import { useEffect, useRef, useState } from 'react';
import { api, withQuery } from '../api.js';

/**
 * Търсене с падащ списък за номенклатури, които са твърде дълги за
 * обикновено меню — стоките са близо седем хиляди, контрагентите пет.
 *
 * Празно поле значи „всички“: филтърът не се прилага, докато не се
 * избере нещо, и се маха с кръстчето.
 */
export default function Lookup({ url, value, label, onPick, placeholder, params }) {
  const [text, setText] = useState('');
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  // Стесняването (`type=agent` например) пътува като параметри, а не
  // залепено за адреса — иначе вторият въпросителен знак чупи заявката.
  const extra = JSON.stringify(params ?? {});

  useEffect(() => {
    if (!open || text.trim().length < 2) { setItems([]); return undefined; }
    const timer = setTimeout(() => {
      api.get(withQuery(url, { ...JSON.parse(extra), q: text.trim(), limit: 20 }))
        .then((res) => setItems(res.items ?? res ?? []))
        .catch(() => setItems([]));
    }, 250);
    return () => clearTimeout(timer);
  }, [text, open, url, extra]);

  useEffect(() => {
    const away = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', away);
    return () => document.removeEventListener('mousedown', away);
  }, []);

  if (value) {
    return (
      <span className="picked">
        {label}
        <button className="link" onClick={() => { onPick(null, null); setText(''); }} title="махни">×</button>
      </span>
    );
  }

  return (
    <span className="lookup" ref={box}>
      <input
        value={text}
        placeholder={placeholder ?? 'търсене'}
        autoComplete="off"
        onChange={(e) => { setText(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
      />
      {open && items.length > 0 && (
        <div className="lookup-list">
          {items.map((it) => (
            <button
              key={it.id}
              type="button"
              className="lookup-item"
              /*
               * onMouseDown, не onClick — и с preventDefault. Иначе тапът на
               * телефон първо размива фокуса от текстовото поле (клавиатурата
               * тръгва да се прибира, страницата се пренарежда) и React
               * никога не получава последвалия „click" върху вече изместения
               * бутон: изборът просто не се случва, полето си остава празно.
               * Виж същия шаблон в Returns.jsx.
               */
              onMouseDown={(e) => {
                e.preventDefault();
                onPick(it.id, it.name);
                setOpen(false);
                setText('');
              }}
            >
              {it.name}
              {it.code ? <span className="muted"> · {it.code}</span> : null}
            </button>
          ))}
        </div>
      )}
    </span>
  );
}
